import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { ReactComponent as StudentHubImage } from "shared/assets/student-hub/card-image.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CardNavButton from "UIPalette/CardNavButton/CardNavButton";

export const StudentWellbeingHubCard = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "studentHub" });
  const navigate = useNavigate();

  return (
    <RoundedCard className="flex flex-col !p-0 overflow-hidden">
      <div className="py-6 pl-6 relative w-full">
        <div className="space-y-4 w-3/4">
          <h2>{t("studentHubNavCard.title")}</h2>
          <p className="w-3/4">{t("studentHubNavCard.description")}</p>
          <StudentHubImage className="absolute top-0 right-0 h-[165px]" />
        </div>
      </div>
      <CardNavButton
        label={t("studentHubNavCard.navLabel")}
        onClick={() => navigate("/student-hub")}
        aria-label={t("studentHubNavCard.navAriaLabel")}
      />
    </RoundedCard>
  );
};
